import { render, staticRenderFns } from "./sendDocumentDialog.vue?vue&type=template&id=3b852d41&scoped=true&"
import script from "./sendDocumentDialog.vue?vue&type=script&lang=js&"
export * from "./sendDocumentDialog.vue?vue&type=script&lang=js&"
import style0 from "./sendDocumentDialog.vue?vue&type=style&index=0&id=3b852d41&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b852d41",
  null
  
)

export default component.exports